import React from "react";
import '../../assets/styles/index.scss';
import '../../assets/styles/themes/soma.scss';

const SomaDS = () => {
  return <div>
    
    <div className="App soma">
      <header>
        <span>
        <a className="btn-back" href="./"><svg width="95" height="8" viewBox="0 0 95 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.646447 3.64645C0.451184 3.84171 0.451184 4.15829 0.646447 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646447 3.64645ZM95 3.5H1V4.5H95V3.5Z"  />
          </svg>
          </a>
          <strong>Soma Design System</strong>
        </span>
        {/* <ul className="menu-languages">
          <li className="active">EN</li>
          <li>ES</li>
          <li>PT</li>
        </ul> */}
        <span>
        <a className="link" href="#contact">Contact</a>
        </span>
      </header>

      <section className="cover">
        <span className="cover-name">Soma Design System</span>
      </section>

      <section className="cover-img">
        <img src={require('../../img/soma-mockup.jpg')} />
      </section>

      <div className="container">
        <div className="col1">
          <h1 class="casepage-title">
            <span className="casepage-title_hat">DesignOps <span className="dash"></span> Project Lead</span>
            <span className="casepage-title_postname">Soma Design System</span>
          </h1>
        </div>

        <div className="col2 casepage-client">
          <span className="casepage-partnership">by <a target="_blank" href="http://meiuca.design">Meiuca</a> for <svg width="49" height="10" viewBox="0 0 69 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7703 10.713L10.7697 10.7119L10.7658 10.7053C9.99197 9.39027 9.21899 8.0766 8.44489 6.7571L9.43472 5.07289C10.4261 3.38606 11.4175 1.69923 12.4152 0H8.10874C7.55839 0.937195 7.00804 1.87132 6.44625 2.82488L6.44507 2.82688L6.44442 2.82788L6.28979 3.09044L5.71184 2.10861C5.29206 1.39549 4.8788 0.693414 4.47081 0H0.332416C0.833921 0.853288 1.33323 1.70225 1.83097 2.54855L1.83218 2.55062L1.83279 2.55165L1.83329 2.55252C2.63221 3.91091 3.42709 5.26245 4.22056 6.61401C3.57394 7.71464 2.92888 8.81137 2.2836 9.90856L2.28264 9.91019L2.28157 9.912C1.52244 11.2027 0.762721 12.4944 0 13.7932H4.31021C4.99371 12.6334 5.67722 11.4698 6.37566 10.2807C7.07409 11.4698 7.76138 12.637 8.44112 13.7895H12.5795C11.9753 12.7609 11.3726 11.7366 10.7703 10.713ZM13.9353 0.0256906H14.1295C14.7957 0.0256906 15.4617 0.0252828 16.1278 0.0248749C17.4599 0.0240593 18.7921 0.0232437 20.1242 0.0256906C20.9609 0.0293609 21.7901 0.12846 22.5856 0.385386C23.4335 0.66066 24.1581 1.11579 24.6697 1.85353C25.0283 2.36738 25.23 2.94362 25.3234 3.5529C25.4541 4.4081 25.4392 5.25962 25.2226 6.10015C24.8752 7.45447 24.0087 8.35742 22.6902 8.84923C22.0776 9.08046 21.439 9.20523 20.7853 9.2603C20.1374 9.31636 19.4894 9.31227 18.8427 9.30825C18.5575 9.30644 18.2724 9.30463 17.9878 9.30802H17.7488V13.7565H13.9353V0.0256906ZM17.8196 6.20498C17.843 6.20778 17.8637 6.21022 17.8833 6.21022C18.0678 6.21022 18.2523 6.21087 18.4369 6.21145C18.8988 6.21297 19.3612 6.21442 19.8255 6.20655C20.0794 6.20287 20.3334 6.16986 20.5799 6.11112C21.1029 5.98267 21.4128 5.63767 21.4987 5.12015C21.5361 4.88157 21.5473 4.63199 21.5324 4.38975C21.4913 3.7768 21.1215 3.3547 20.5127 3.21156C20.3334 3.16752 20.1466 3.14182 19.9599 3.14182C19.4475 3.13632 18.935 3.13701 18.421 3.13769C18.2494 3.13792 18.0776 3.13815 17.9057 3.13815C17.8738 3.13815 17.8436 3.14131 17.8128 3.14452C17.7967 3.1462 17.7805 3.1479 17.7637 3.14917V6.19926C17.7841 6.20078 17.8025 6.20299 17.8196 6.20498ZM18.3464 9.89526H18.5556C18.6968 9.89526 18.8384 9.89584 18.9802 9.89648H18.9813C19.3374 9.89794 19.6946 9.89946 20.0496 9.89158C21.0431 9.86592 22.0217 9.73747 22.9516 9.37772C24.4382 8.80518 25.4093 7.77012 25.7977 6.23957C26.0704 5.17152 26.0742 4.09243 25.8164 3.02436C25.4989 1.72138 24.7407 0.745068 23.5082 0.14313C23.4559 0.117438 23.4036 0.0880746 23.3588 0.0366897H43.005C43.0068 0.0403601 43.0087 0.0431129 43.0106 0.0458656C43.0125 0.0485987 43.0143 0.0513976 43.0161 0.0550415C43.0199 0.0587119 43.0236 0.0660526 43.0199 0.0697229C43.005 0.102756 42.99 0.135789 42.9713 0.168822C41.6379 2.43533 40.3054 4.70184 38.9729 6.96832C37.6404 9.23475 36.308 11.5011 34.9747 13.7675H18.3464V9.89526ZM43.0423 13.7639V3.47216H46.628V4.14383C46.6587 4.12326 46.6863 4.10468 46.7116 4.08757C46.7632 4.05279 46.8058 4.02408 46.8483 3.99702C47.345 3.64466 47.8941 3.40242 48.4992 3.30699C49.1341 3.20789 49.7653 3.21523 50.3853 3.39141C51.3154 3.652 51.9241 4.25394 52.279 5.12382C52.5031 5.67437 52.6152 6.25059 52.6451 6.83789C52.6637 7.22692 52.6712 7.61968 52.6712 8.01237C52.6737 9.24333 52.6728 10.4758 52.672 11.7079V11.7091C52.6716 12.3245 52.6712 12.9398 52.6712 13.5546V13.7675H49.037V7.95002C49.037 7.64902 49.0258 7.35175 48.9474 7.0581C48.854 6.70944 48.6784 6.42314 48.3087 6.30566C47.9837 6.20655 47.6588 6.21022 47.3376 6.31668C47.0425 6.41212 46.8595 6.62865 46.7698 6.9076C46.7026 7.10943 46.6728 7.32229 46.6429 7.53515C46.6284 7.65211 46.6296 7.77146 46.6309 7.89116C46.6313 7.92546 46.6317 7.95976 46.6317 7.99406V13.7675C45.4327 13.7639 44.2488 13.7639 43.0423 13.7639ZM61.512 6.8474C62.067 6.43463 62.6196 6.02362 63.1851 5.60099C63.109 5.49603 63.0371 5.39333 62.9675 5.29325C62.8832 5.17293 62.8018 5.05617 62.7186 4.94399C62.0687 4.11449 61.2466 3.54192 60.1863 3.34372C59.1702 3.15653 58.1616 3.22627 57.1831 3.55293C56.1821 3.88694 55.4164 4.51457 54.8935 5.41747C54.5349 6.03044 54.3295 6.69107 54.2287 7.38844C54.0979 8.28771 54.1091 9.18324 54.266 10.0752C54.3818 10.7358 54.5947 11.3671 54.9495 11.9433C55.5434 12.916 56.4137 13.5253 57.5229 13.8116C58.2364 13.9951 58.9572 14.0355 59.6891 13.9658C60.3544 13.9033 60.9777 13.7125 61.5421 13.3491C62.0835 13.0005 62.5205 12.5416 62.9127 12.0388C62.9905 11.9368 63.0654 11.8334 63.1421 11.7276C63.1869 11.6659 63.2317 11.6031 63.2789 11.5396C62.7216 11.1142 62.1737 10.6947 61.6247 10.2739L61.6217 10.2715L60.9966 9.79253L60.9671 9.83237C60.8822 9.94852 60.8043 10.054 60.7241 10.1596C60.5148 10.4275 60.2942 10.6808 60.007 10.8753C59.409 11.279 58.3857 11.279 57.9749 10.3064C57.8927 10.1082 57.8293 9.90267 57.7881 9.69342C57.6612 9.05112 57.6724 8.40146 57.7545 7.75548C57.7994 7.39579 57.889 7.04713 58.0683 6.72414C58.3335 6.25432 58.7891 6.04508 59.3235 6.12955C59.6667 6.18456 59.9468 6.34976 60.1527 6.61768C60.2653 6.76497 60.3656 6.92142 60.4658 7.07799L60.4664 7.07881C60.5083 7.14432 60.5502 7.20982 60.5932 7.27469L60.5938 7.27557C60.6274 7.33028 60.6604 7.38517 60.7017 7.45086C60.9736 7.24827 61.2431 7.04766 61.512 6.8474ZM41.003 13.7675H37.4398C37.4383 13.744 37.4365 13.7222 37.4346 13.701C37.4314 13.666 37.4285 13.633 37.4285 13.5987C37.4285 12.6995 37.4285 11.8002 37.4248 10.901C37.4248 10.7908 37.4547 10.6991 37.5108 10.6073C37.9737 9.82217 38.4358 9.03694 38.8978 8.25177C39.3602 7.46602 39.8226 6.68033 40.2859 5.89458L40.9358 4.78248C40.9544 4.75317 40.9731 4.72369 40.9992 4.68705C41.0403 4.82285 41.0478 13.573 41.003 13.7675ZM68.6308 10.4826C68.1749 9.81085 67.5068 9.53557 66.8156 9.51358C65.0564 9.51726 64.1488 10.8606 64.4513 12.248C64.8358 14.0024 66.8905 14.4465 68.1118 13.5473C68.6344 13.1619 68.9109 12.6407 68.9817 12.0058C69.0454 11.4552 68.9446 10.9413 68.6308 10.4826Z" fill="#212121" />
          </svg> | São Paulo, Brazil</span>
        </div>
      </div>

      <section className="process">
        <div className="process_step">
          <h3 className="process_step_title"><span className="process_step_number">1</span>Defining Principles</h3>
          <p>Five principles dealed with all designers of the company.</p>
        </div>
        <div className="process_step">
          <h3 className="process_step_title"><span className="process_step_number">2</span>Mapping Processes</h3>
          <p>Optimizing and creating design/dev processes.</p>
        </div>
        <div className="process_step">
          <h3 className="process_step_title"><span className="process_step_number">3</span>Design System Libraries</h3>
          <p>The first version of the libs for designers and developers.</p>
        </div>
        <div className="process_step">
          <h3 className="process_step_title"><span className="process_step_number">4</span>Docs & Implement</h3>
          <p>All documentation needed for the product teams.</p>
        </div>
      </section>

      <section className="cover-img proto">
          <video src={require('../../img/prototype-soma.mp4')} width="750" height="500" autoPlay loop muted/>
      </section>

      <div className="container">
        <div className="col1">
        </div>

        <div className="col2">
        <p className="casepage-paragraphy">The XP Inc.'s product teams are huge: +70 designers and +100 product squads. It was a big challenge to envolve all this people along the Design System development, but it was the big difference.</p>
          <p className="casepage-paragraphy">With a DesignOps dedicated team, we brought designers, developers and product managers to the table, and together we defined Principles, Process, Libraries and Governance.</p>
          <h2 class="casepage-deliverables">
            <span className="casepage-deliverables_hat">For Designers</span>
            <span className="casepage-deliverables_text">Figma Library</span>
          </h2>
          <h2 class="casepage-deliverables">
            <span className="casepage-deliverables_hat">For Technology</span>
            <span className="casepage-deliverables_text">Web Components, <br></br> iOS & Android</span>
          </h2>
          <h2 class="casepage-deliverables">
            <span className="casepage-deliverables_hat">Documentation</span>
            <span className="casepage-deliverables_text">Zero Height, <br></br>Storybook & Azure</span>
          </h2>
        </div>
      </div>

      <div className="case-gallery">
        <div class="case-gallery_col1">
          <figure className="case-gallery_photo">
            <img src={require('../../img/soma-mockup.jpg')} />
          </figure>
        </div>
        <div class="case-gallery_col2">
        <figure className="case-gallery_photo">
            <img src={require('../../img/xp-2.png')} />
          </figure>
          <figure className="case-gallery_photo">
            <img src={require('../../img/xp-3.png')} />
          </figure>
        </div>
      </div> 

      <section className="colaborators container">
        <div class="col1"><strong>My role</strong> <br></br>Project Lead, Visual Designer [Website]</div>
        <div class="col2">
            <ul>
                <strong>Also in this project</strong>
                <li>Thiago Hassu</li>
                <li>Sol Lima</li>
                <li>Felipe Oliveira</li>
                <li>Isaque Pereira</li>
                <li>Raphael Sonsino</li>
                <li>James Cordeiro</li>
                <li>Fernando Dutra</li>
                <li>Vinicius Albino</li>
                <li>Gabriel Coutinho</li>
                <li>Willian Kuester</li>
                <li>Marcello Oliveira</li>
            </ul>

            <ul>
                <strong>Pics</strong>
                <li>Matheus Ferreira</li>
            </ul>
        </div>
      </section>


      <section className="articles">
      <a href="./redesign-now" className="article">
          <figure>
            <img src={require('../../img/now-full.jpg')} />
          </figure>
          <div className="article-title">
            <span className="article-title_hat">Design Sprint</span>
            <span className="article-title_postname">Redesign Now TV <br></br> for Claro Brasil</span>
          </div>
          <span className="link-arrow">
            <svg width="231" height="8" viewBox="0 0 231 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M227.172 0.464318L230.354 3.6463C230.549 3.84156 230.549 4.15814 230.354 4.3534L227.172 7.53539C226.976 7.73065 226.66 7.73065 226.464 7.53539C226.269 7.34012 226.269 7.02354 226.464 6.82828L228.793 4.49985H0V3.49985H228.793L226.464 1.17142C226.269 0.976162 226.269 0.65958 226.464 0.464318C226.66 0.269056 226.976 0.269056 227.172 0.464318Z"  />
            </svg>
          </span>
        </a>
      </section>

      <footer id="contact">
        <span className="footer-heading">don't be shy, contact me.</span>
        <span className="footer-links">
          <a target="_blank" className="link" href="mailto:glauberlaender@gmail.com">Mail</a>
          <a target="_blank" className="link" href="tel:+5511941870613">Phone</a>
          <a target="_blank" className="link" href="http://linkedin.com/in/glauberlaender">Linkedin</a>
          <a target="_blank" className="link" href="http://twitter.com/glauberlaender">Twitter</a>
          <a target="_blank" className="link" href="http://instagram.com/glauberlaender">Instagram</a>
          <a target="_blank" className="link" href="http://savee.it/g_laender">Savee</a>
          <a target="_blank" className="link" href="http://pinterest.com/glauberlaender">Pinterest</a>
        </span>

        <p>by the way, this website was <a target="_blank" className="link" href="https://github.com/glauberlaender/laender.me/tree/master/laender-me">coded by me</a>.</p>
      </footer>

    </div>

  </div>;
};

export default SomaDS;
